document.addEventListener("DOMContentLoaded", function () {

  const root = document.getElementById("drop-root");
  if (!root) return;

  const start = parseInt(root.dataset.start) * 1000;
  const end = parseInt(root.dataset.end) * 1000;
  const queueLimit = parseInt(root.dataset.queue);
  const vipPassword = root.dataset.vip;

  const now = window.serverTime;

  const countdownEl = document.getElementById("drop-countdown");
  const enterBtn = document.getElementById("drop-enter");
  const vipInput = document.getElementById("vip-input");
  const queueMsg = document.getElementById("drop-queue-message");

  function activateDrop() {
    root.style.display = "block";
    document.body.classList.add("drop-lock");
  }

  if (now < start) {
    activateDrop();
    startCountdown(start);
    enterBtn.style.display = "none";
  }

  if (now >= start && now <= end) {
    activateDrop();
    countdownEl.style.display = "none";

    let activeUsers = localStorage.getItem("dropActiveUsers");
    activeUsers = activeUsers ? parseInt(activeUsers) : 0;

    if (activeUsers >= queueLimit) {
      queueMsg.innerHTML = "You are in queue. Please wait...";
      enterBtn.style.display = "none";
    }
  }

  enterBtn.addEventListener("click", function () {

    if (vipPassword && vipInput.value === vipPassword) {
      unlock();
      return;
    }

    let activeUsers = localStorage.getItem("dropActiveUsers");
    activeUsers = activeUsers ? parseInt(activeUsers) : 0;

    if (activeUsers < queueLimit) {
      localStorage.setItem("dropActiveUsers", activeUsers + 1);
      unlock();
    }
  });

  function unlock() {
    root.style.display = "none";
    document.body.classList.remove("drop-lock");
  }

  function startCountdown(target) {
    setInterval(() => {
      const now = window.serverTime += 1000;
      const distance = target - now;

      if (distance <= 0) location.reload();

      const hours = Math.floor((distance / (1000*60*60)) % 24);
      const minutes = Math.floor((distance / 1000/60) % 60);
      const seconds = Math.floor((distance / 1000) % 60);

      countdownEl.innerHTML =
        hours + "h " + minutes + "m " + seconds + "s";
    }, 1000);
  }

});